import { FormProps } from 'react-final-form';

import { Voucher_Source_Type, Voucher_State } from '@occc/graphql';

export type SourceTypeFilterValue = Voucher_Source_Type | 'any';

export type StateFilterValue = Voucher_State | 'any';

export type SourceTypeSelectOption = {
  label: string;
  value: SourceTypeFilterValue;
};

export type StateSelectOption = {
  label: string;
  value: StateFilterValue;
};

export enum DateRange {
  Last1H = 'last1h',
  Last6H = 'last6h',
  Last24H = 'last24h',
  Prev24H = 'prev24h',
  Custom = 'custom',
}

export type DateRangeFilterValue = DateRange | 'any';

export type CreatedAtSelectOption = {
  label: string;
  value: DateRangeFilterValue;
};

export type ExpireAtSelectOption = {
  label: string;
  value: DateRangeFilterValue;
};

export type VouchersFilterFormValuesDate = {
  range: DateRangeFilterValue;
  start: Date | null;
  end: Date | null;
};

export type VouchersFilterFormValues = {
  sourceType: SourceTypeFilterValue;
  state: StateFilterValue;
  createdAt: VouchersFilterFormValuesDate;
  expireAt: VouchersFilterFormValuesDate;
};

export type VouchersFilterFormProps = {
  onSubmit: FormProps<VouchersFilterFormValues>['onSubmit'];
  onReset: () => void;
  initialValues: VouchersFilterFormValues;
};
